export enum ProdutosTypes {
  'LOAD_REQUEST' = '@produtos/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@produtos/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@produtos/LOAD_FAILURE',

  'CLEAN_PRODUTOS' = '@produtos/CLEAN_PRODUTOS',
}

export interface IProdutos {
  codProduto: number;
  codReferencia: string;
  descricao: string;
  referencia: string;
}

export interface ProdutosState {
  readonly data: IProdutos[];
  readonly loading: boolean;
  readonly error: boolean;
}
